<template>
  <v-row no-gutters>
    <v-col cols="12" sm="4" md="3" lg="2" style="margin: 6px">
      <no-autocomplete-textfield
      :placeholder="$t('components.formulabuilder.set_a_value')"
        :label="$t('components.compositewithprovinceparameter.province_code')"
        v-model="code"
        outlined
        dense
        hide-details
      />
    </v-col>
    <v-col
      cols="12"
      sm="4"
      md="3"
      lg="2"
      style="margin: 6px"
      v-for="province of Object.keys(provinces)"
      :key="province"
    >
      <no-autocomplete-textfield
        v-model="provinces[province]"
        :label="province"
        outlined
        dense
        hide-details
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";

export default {
  components: {NoAutocompleteTextfield},
  props: ["name", "parameter"],
  data() {
    return {
      // internal: null,
      code: null,
      provinces: [],
    };
  },
  watch: {
    parameter: {
      handler(v) {
        this.init();
      },
    },
  },
  async mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.parameter === null || this.parameter === undefined) {
        return;
      }
      //console.log(this.parameter);
      this.provinces = JSON.parse(this.parameter.value);
      // this.internal = this.parameter
    },
  },
};
</script>
